// React
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Components
import Box from "components/Atoms/Box";
import Typography from "components/Atoms/Typography/TypographyV1";
import InfoModal from "components/Modals/InfoModal";

function UploadHelpModal({ open, onClose }) {
  const { t } = useTranslation(["common"]);

  return (
    <InfoModal open={open} onClose={onClose} title={t("uploadHelp.title")}>
      <Box>
        <Typography variant="h6" fontWeight="medium" mb={1}>
          {t("uploadHelp.notes")}
        </Typography>
        <Typography variant="body2" mb={2}>
          • {t("uploadHelp.verifyTemplate")}
        </Typography>
        <Typography variant="body2" mb={2}>
          • {t("uploadHelp.timezoneNote")}
        </Typography>
        <Typography variant="body2" mb={2}>
          • {t("uploadHelp.consumptionNote")}
        </Typography>
        <Typography variant="body2" mb={2}>
          • {t("uploadHelp.timeIntervalNote")}
        </Typography>
        <Typography variant="h6" fontWeight="medium" mt={3} mb={1}>
          {t("uploadHelp.midnightTitle")}
        </Typography>
        <Typography variant="body2" mb={1}>
          {t("uploadHelp.midnightNote")}
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#1e2a3a" : "#f5f5f5"),
            color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1a202c"),
            border: (theme) =>
              theme.palette.mode === "dark" ? "1px solid rgba(255,255,255,0.1)" : "none",
            padding: 2,
            borderRadius: 1,
            fontFamily: "monospace",
            fontSize: "0.8rem",
            mb: 2,
            overflowX: "auto",
          }}
        >
          {t("uploadHelp.midnightExample")}
        </Box>
        <Typography variant="h6" fontWeight="medium" mt={3} mb={1}>
          {t("uploadHelp.dstForwardTitle")}
        </Typography>
        <Typography variant="body2" mb={1}>
          {t("uploadHelp.dstForwardNote")}
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#1e2a3a" : "#f5f5f5"),
            color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1a202c"),
            border: (theme) =>
              theme.palette.mode === "dark" ? "1px solid rgba(255,255,255,0.1)" : "none",
            padding: 2,
            borderRadius: 1,
            fontFamily: "monospace",
            fontSize: "0.8rem",
            mb: 2,
            overflowX: "auto",
          }}
        >
          {t("uploadHelp.dstForwardExample")}
        </Box>
        <Typography variant="h6" fontWeight="medium" mt={3} mb={1}>
          {t("uploadHelp.dstBackwardTitle")}
        </Typography>
        <Typography variant="body2" mb={1}>
          {t("uploadHelp.dstBackwardNote")}
        </Typography>
        <Box
          component="pre"
          sx={{
            backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#1e2a3a" : "#f5f5f5"),
            color: (theme) => (theme.palette.mode === "dark" ? "#e2e8f0" : "#1a202c"),
            border: (theme) =>
              theme.palette.mode === "dark" ? "1px solid rgba(255,255,255,0.1)" : "none",
            padding: 2,
            borderRadius: 1,
            fontFamily: "monospace",
            fontSize: "0.8rem",
            overflowX: "auto",
          }}
        >
          {t("uploadHelp.dstBackwardExample")}
        </Box>
      </Box>
    </InfoModal>
  );
}

UploadHelpModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UploadHelpModal;
